//------------------------actions 定义规则说明-----------------------
//      actions  旨在 为mutation 变化注册一个方法，也可以将多个mutation变化 注册到一个业务中
// 所以把每个action看做一个业务逻辑处理，并按照  实体类型（例如:menu,user...）  分类 摆放
//      actions 命名：驼峰（实体名+动作名）
//---------------------------------------------------------------------

// 解构赋值 方法
function makeAction(type){
    return ({ dispatch},...args )=>dispatch(type,...args);
};

//----------------菜单--menuList--------------------
//1.1 菜单信息  初始化(更新)
export const menuListInit=makeAction('MENULIST_INIT');

//-----------------登录用户--sessionUser---------------------
//2.1登录
export const sessionUserLogin=makeAction('SESSIONUSER_LOGIN');
//2.2 注销
export const  sessionUserLogout=makeAction('SESSIONUSER_LOGOUT');
 // 2.3 更新sessionUser
 export const  sessionUserUpdate=makeAction('SESSIONUSER_UPDATE');


//-----------------報表--stdQuery---------------------
//3.1 更新sessionUser
 export const  queryNameUpdate=makeAction('QUERYNAME_UPDATE');
 //3.2.1 报表查询参数更新
 export const queryParamsUpdate=makeAction('QUERYPARAMS_UPDATE');
 //3.2.2 报表查询参数 配置数据
 export const queryParamConfigUpdate=makeAction('queryParamConfig_UPDATE');
 export const queryParamConfigUpdate2=makeAction('queryParamConfig_UPDATE2');
  //3.3 报表数据更新
 export const  queryDataUpdate=makeAction('QUERYDATA_UPDATE');
 // 3.4 清空报表数据
export const  queryDataReset=makeAction('QUERYDATA_RESET');
 // 3.5.1 弹出框配置数据更新
 export const  smallQueryConfigDataUpdate=makeAction('SMALLQUERYCONFIGDATA_UPDATE');
  // 3.5.2 弹出框配置数据清空
 export const  smallQueryConfigDataReset=makeAction('SMALLQUERYCONFIGDATA_RESET');
// 3.5.3 弹出框配置数据清空
export const  queryConfigDataReset=makeAction('QUERYPARAMCONFIGDATA_RESET');

 // 3.6 模态框回显值
export const  smallQueryReturnValUpdate=makeAction('SMALLQUERYRETURNVAL_UPDATE');
// 3.7 模态框 查询 结果 总数
export const  smallQueryTotalCountUpdate=makeAction('SMALLQUERYTOTALCOUNT_UPDATE');
//3.7 模态框查询参数更新
export const smallQueryParamsUpdate=makeAction('SMALLQUERYPARAMS_UPDATE');
// 3.7 模态框 查询 结果
export const  smallQueryDataUpdate=makeAction('SMALLQUERYDATA_UPDATE');
// 3.8 弹出框查询结果 清空
export const  smallQueryDataReset=makeAction('SMALLQUERYDATA_RESET');
 //3.9 弹出框业务类型  枚举
export const  SmallQueryTypeUpdate=makeAction('SmallQueryType_UPDATE');
 //3.10 SmallQueryHideParam 弹出框隐藏参数
export const  SmallQueryHideParamUpdate=makeAction('SmallQueryHideParam_UPDATE');
//3.11 pageObject
export const  pageObjectUpdate=makeAction('pageObject_UPDATE');
 //-----------------模塊--stdModule---------------------
 //4.1模块配置数据
 export const  moduleConfigDataUpdate=makeAction('MODULECONFIGDATA_UPDATE');
  //4.1.1 清空DataList
 export const  DataListReset=makeAction('DataList_RESET');
  //4.2 当前审核步骤 auditStep
 export const  auditStepUpdate=makeAction('AUDITSTEP_UPDATE');
 //4.3 模块4种状态：Normal（默认），Add，Modify，Del
  export const  moduleStateUpdate=makeAction('MODULESTATE_UPDATE');
 //4.4 业务标记
 export const  BusPowIDUpdate=makeAction('BusPowID_UPDATE');
 //4.5.1 更新当前单据DataObject
 export const  DataObjectUpdate=makeAction('DataObject_UPDATE');


//4.5.2 单据详情 赋值 更新数据
 export const  DataObjectModify=makeAction('DataObject_MODIFY');
//4.5.3 单据详情 重置
 export const  DataObjectReset=makeAction('DataObject_RESET');

//4.5.4 设置dataObject的参数
 export const DataObjectParams = makeAction('DataObject_PARAMS');

 //4.6 更新当前Grid Tab编号 TabId_Now
export const TabId_NowUpdate=makeAction('TabId_Now_UPDATE');
  //4.7 业务操作
 export const bizQueryBatchExecute = makeAction('BizQueryBatch_EXECUTE');


 //5.0 报表模块初始化
export const stdQueryConfigDataInit = makeAction('StdQueryConfig_INIT');

//5.2 报表查询条件参数
export const stdQueryChartData = makeAction('STDQueryChart_DATA');

//5.0 homeData_Load
export const homeDataLoad = makeAction('homeData_Load');
//5.1
export const WaitOrderUpdate = makeAction('WaitOrder_Update');

//6.0  初始化平台信息
export const systemInfo_Init  = makeAction('SYSTEMINFO_INIT');
//6.1为elTable 设置操作按钮对象
export const operationButtonInit = makeAction('OPERATION_BUTTON_INIT');
// 6.2 重置elTable 设置的操作按钮对象
export const operationButtonResert = makeAction('OPERATION_BUTTON_RESERT');
// 6.3  为smallQuery 查询 带入预设的查询参数
export const smallQueryAddParamFromParent = makeAction('SmallQuery_Add_Param_FromParent');
//6.4 清除  查询预设的查询参数 和要求隐藏的列表
export const smallQueryClearParamsAndHide = makeAction('SmallQuery_Clear_Params_And_Hide');

//6.5 设置 B00005 模块  根据条码找出的基础资料信息，供第二步 匹配
export const SetMainBarGodeGoodsData = makeAction('Set_MainBarGode_Goods_Data');
//6.6 清除 B00005 模块  根据条码找出的基础资料信息
export const ClearMainBarGodeGoodsData = makeAction('Clear_MainBarGode_Goods_Data');

//6.7 B00005 模块  获取商品分类
export const GoodsCategoryData = makeAction('GETGOODSCATEGORY_DATA');

//6.8 pageObject 重置
export const PageObjectResert = makeAction('PAGEOBJECT_RESERT');

//6.9 B00005 模块  根据条码获取图片信息
export const GoodsPictureData = makeAction('GETGOODSPICTURE_DATA');

//7.0 a00003 模块  获取系统参数信息
export const SysParamsInfo = makeAction('GETSYSPARAMSINFO_DATA');
export const TableData = makeAction('GETTABLE_DATA');



// WEBPACK FOOTER //
// ./src/vuex/actions.js